import { render, staticRenderFns } from "./RatingWorktypesIndex.vue?vue&type=template&id=f2035b42"
import script from "./RatingWorktypesIndex.vue?vue&type=script&lang=js"
export * from "./RatingWorktypesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports